var exports = {
  "pj": "ownerDropdownOverlay__KgDKpB",
  "BR": "ownerListGroup__7Zeyk0",
  "Fx": "ownerListItem__lIooF4",
  "Xd": "orgLabel__tyK-gR",
  "_b": "errorListItem__bAmKq8",
};

module.exports = exports;
